import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancelBookingComponent } from './cancel-booking.component';
import { APP_ROUTES_MAIN } from './cancel-booking.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateComponent } from './create/create.component';
import { ListComponent } from './list/list.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    CancelBookingComponent,
    CreateComponent,
    ListComponent
  ],
  imports: [
    APP_ROUTES_MAIN,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class CancelBookingModule { }
